// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Co1r7","content":"_3be6hS","title":"_2a_sU3"};